// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3bswt","bigColWidth":"Table_bigColWidth__15pd9","biggerColWidth":"Table_biggerColWidth__1dzDP","row":"Table_row__2Eo-L","col":"Table_col__3rI6h"};